// extracted by mini-css-extract-plugin
export default {"inputText":"styles_inputText__adtXB","inputTextWrapper":"styles_inputTextWrapper__Jj9qq"};